const styles = {
  instruction: {
    textAlign: 'center',
    fontWeight: 600,
    marginBottom: 30,
  },
};

export default styles;
